module.exports = __webpack_public_path__ + "static/media/Matheson Street, Healdsburg, CA1.b29dd87a.jpg";